<template>
    <v-card tile>
        <div class="card-title">
            {{ $t('ElibraryCategories') }}
        </div>
        <v-data-table :headers="headers" dense :items="elibraryCategories" :items-per-page="10">
            <template v-slot:[`item.options`]="{ item }">
                <v-icon class="me-3" color="secondary" @click="editItem(item)"> mdi-pen</v-icon>
                <v-icon color="error" @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
            <template v-slot:top>
                <v-btn small class="ma-4 white--text" tile color="primary" @click="open()">
                    {{ $t('Add') }} <v-icon small class="ms-2">mdi-plus</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-form ref="elibraryCategoryForm" v-model="valid" lazy-validation>
            <CommonDialog v-model="dialog" :fullscreen="false" width="500" :title="title" show-action-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="eLibraryCategory.nameAr" :label="$t('NameAr')" :rules="nameRules" required />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="eLibraryCategory.nameEn" :label="$t('NameEn')" :rules="nameRules" required />
                        </v-col>
                    </v-row>
                </v-container>

                <template v-slot:actions>
                    <v-btn v-if="!edit" color="primary" class="white--text" tile :disabled="loading" small @click="save()">
                        {{ $t("Add") }}
                    </v-btn>
                    <v-btn v-if="edit" color="primary" class="white--text" tile :disabled="loading" small @click="update()">
                        {{ $t("Update") }}
                    </v-btn>
                    <v-btn color="error" class="white--text" tile :disabled="loading" small @click="dialog = false; reset()">
                        {{ $t("Cancel") }}
                    </v-btn>
                </template>
            </CommonDialog>
        </v-form>
    </v-card>
</template>

<script>
    import CommonDialog from '@/components/controls/CommonDialog'
    import ElibraryCategoryService from '@/services/ElibraryCategoryService.js'

    export default {
        components: {
            CommonDialog
        },
        
        data() {
            return {
                loading: false,
                valid: true,
                dialog: false,
                edit: false,
                title: '',
                selectedCategoryId: null,
                elibraryCategories: [],
                headers: [
                    { text: this.$t('Id'), value: 'id' },
                    { text: this.$t('NameAr'), value: 'nameAr' },
                    { text: this.$t('NameEn'), value: 'nameEn' },
                    { text: this.$t('Options'), value: 'options', width: '8%' }
                ],
                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                eLibraryCategory: {
                    nameAr: '',
                    nameEn: '',
                }

            }
        },
        
        created() {
            this.loadElibraryCategories()
        },
       
        methods: {
            reset() {
                this.eLibraryCategory.nameAr = ''
                this.eLibraryCategory.nameEn = ''
                this.selectedCategoryId = null
            },

            open() {
                this.reset()
                this.edit = false
                this.selectedCategoryId = null
                this.$refs.elibraryCategoryForm.resetValidation()
                this.title = this.$t('Add')
                this.dialog = true
            },

            editItem(item) {
                this.edit = true
                this.eLibraryCategory.nameAr = item.nameAr
                this.eLibraryCategory.nameEn = item.nameEn
                this.selectedCategoryId = item.id
                this.title = this.$t('Edit')
                this.dialog = true
            },

            loadElibraryCategories() {
                this.loading = true
                ElibraryCategoryService.listElibraryCategories().then((res) => {
                    this.elibraryCategories = res.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            save() {
                if (this.$refs.elibraryCategoryForm.validate()) {
                    ElibraryCategoryService.addElibraryCategory(this.eLibraryCategory).then((res) => {
                        this.loadElibraryCategories()
                        this.reset()
                        this.$refs.elibraryCategoryForm.resetValidation()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },

            update() {
                if (this.$refs.elibraryCategoryForm.validate()) {
                    ElibraryCategoryService.updateElibraryCategory(this.selectedCategoryId, this.eLibraryCategory).then((res) => {
                        this.dialog = false
                        this.loadElibraryCategories()
                        this.reset()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },

            async deleteItem(id) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    ElibraryCategoryService.deleteElibraryCategory(id)
                        .then(() => {
                            this.loadElibraryCategories()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => this.loading = false)
                }
            },
        },
    }
</script>

<style>
</style>